export default __webpack_public_path__ + "static/media/entsoe_logo_white.35661ac8.svg";